//@ts-nocheck
import React from 'react';

/** Custom imports */
import { LoginForm } from 'components/elements/LoginForm';

export const User = () => {
  return <LoginForm stlye={{ backgroundColor: 'white' }} />;
};
